import React from 'react';
import { StripeProvider, Elements } from 'react-stripe-elements';
import Head from 'next/head';
import root from 'window-or-global';

interface Props {
  children: React.ReactNode;
}

export default function StripeContainer({ children }: Props) {
  const [stripe, setStripe] = React.useState(null);

  React.useEffect(() => {
    if (root.Stripe) {
      setStripe(root.Stripe('pk_test_Gqmz2ySK51osTTmakqdNb7Cz'));
    } else {
      const scriptId = root.document.querySelector('#stripe-js');
      if (scriptId) {
        scriptId.addEventListener('load', () => {
          // Create Stripe instance once Stripe.js loads
          setStripe(root.Stripe('pk_test_Gqmz2ySK51osTTmakqdNb7Cz'));
        });
      } else {
        setTimeout(() => {
          const scriptId = root.document.querySelector('#stripe-js');
          if (scriptId) {
            scriptId.addEventListener('load', () => {
              // Create Stripe instance once Stripe.js loads
              setStripe(root.Stripe('pk_test_Gqmz2ySK51osTTmakqdNb7Cz'));
            });
          }
        }, 1000);
      }
    }
  }, []);

  return (
    <>
      <Head>
        {!root.Stripe && <script id="stripe-js" src="https://js.stripe.com/v3/" async defer />}
      </Head>
      {stripe ? (
        <StripeProvider stripe={stripe}>
          <Elements>{children}</Elements>
        </StripeProvider>
      ) : null}
    </>
  );
}
